export function isSubscriber(): Ref<boolean> {
  const profile = usePublicProfile();
  return computed(() =>
    profile.value?.pro_until
      ? new Date(profile.value?.pro_until).getTime() > Date.now()
      : false
  );
}
